import { render, staticRenderFns } from "./commentbank.vue?vue&type=template&id=13172a95&scoped=true&"
import script from "./commentbank.vue?vue&type=script&lang=js&"
export * from "./commentbank.vue?vue&type=script&lang=js&"
import style0 from "./commentbank.vue?vue&type=style&index=0&id=13172a95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13172a95",
  null
  
)

export default component.exports